import { EntityModel } from '@/interfaces'
import {
  ALL_PERSONAL_ADDONS_QUERY,
  CREATE_PERSONAL_ADDON_MUTATION,
  DELETE_PERSONAL_ADDON_MUTATION,
  FORCE_DELETE_PERSONAL_ADDON_MUTATION,
  SINGLE_PERSONAL_ADDON_QUERY,
  UPDATE_PERSONAL_ADDON_MUTATION,
} from './graphql'
import travelPricingAgeGroupEntity from '@/entities/travelPricingAgeGroup/entity'
import travelPricingServiceCalculationSettingsEntity from '@/entities/travelPricingServiceCalculationSettings/entity'
import travelPricingMandatorySettingsEntity from '@/entities/travelPricingMandatorySettings/entity'

const ratioPersonalAddonModel: EntityModel = {
  name: 'personalAddon',
  namePlural: 'personalAddons',
  uniqueName: 'ratioPersonalAddon',
  uniqueNamePlural: 'ratioPersonalAddons',
  path: 'travel/pricing/adaptors/ratio/personal_addon',
  baseUrl: '/travel/pricing/adaptors/ratio/personal_addons',
  translationPrefix: 'entities:ratioPersonalAddon.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_PERSONAL_ADDONS_QUERY,
    getSingle: SINGLE_PERSONAL_ADDON_QUERY,
    create: CREATE_PERSONAL_ADDON_MUTATION,
    update: UPDATE_PERSONAL_ADDON_MUTATION,
    delete: DELETE_PERSONAL_ADDON_MUTATION,
    forceDelete: FORCE_DELETE_PERSONAL_ADDON_MUTATION,
  },
  attributes: {
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioPersonalAddon.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:ratioPersonalAddon.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioPersonalAddon.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioPersonalAddon.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    allowedAgeGroups: {
      name: 'allowedAgeGroups',
      label: 'entities:ratioPersonalAddon.attributes.allowedAgeGroups.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelPricingAgeGroupEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    calculationSettings: {
      name: 'calculationSettings',
      label: 'entities:ratioPersonalAddon.attributes.calculationSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingServiceCalculationSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    mandatorySettings: {
      name: 'mandatorySettings',
      label: 'entities:ratioPersonalAddon.attributes.mandatorySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingMandatorySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioPersonalAddonModel
